import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';

function RecipeCardFood(props) {
  const { recipe, index } = props;
  return (
    <div data-testid={ `${index}-recipe-card` } className="recipe-card">
      <Link to={ `/foods/${recipe.idMeal}` }>
        <div className="title-div">
          <h2 data-testid={ `${index}-card-name` } className="recipe-card-title">
            {recipe.strMeal}
          </h2>
        </div>
        <img
          data-testid={ `${index}-card-img` }
          alt={ `${recipe.strMeal}` }
          src={ recipe.strMealThumb }
          className="recipe-card-img"
        />
      </Link>
    </div>
  );
}

RecipeCardFood.propTypes = {
  recipe: PropTypes.object,
  index: PropTypes.number,
}.isRequired;

export default RecipeCardFood;
